import React, { Component , Fragment} from 'react'
import Number from './Number'

export class Numbers extends Component {
  render() {
    return (
      <Fragment>
      <h1 className='our-numbers'>Наши номера</h1>
      <h3 className='out-numbers_desc'> Гостевой дом «Эдельвейс» – это широкий выбор номеров на любой вкус. Выберите свой идеальный номер прямо сейчас!</h3>
      <main className='our-numbers_photo'>
        
        {this.props.numbers.map(el => (
          
          <Number key= {el.id} number={el} />

        ))}
      </main>
      
      </Fragment>
    )
  }
}

export default Numbers